export default __webpack_public_path__ + "static/media/main-nsaa-logo.21c42b4b.png";